export default __webpack_public_path__ + "media/images/Picto_datadocke_100-557665649bd38205671d3222486a76e1.png";